import * as XLSX from 'xlsx';

function formatGender(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  return String(value);
}

function formatQuotaNames(quotaData) {
  return (quotaData ?? [])
    .map((quota) => quota.quota_name || quota.cnq_id)
    .join('; ');
}

/**
 * @param {Array} users - Over-quota user rows to export
 * @param {string|number} studyId - Current study_id (used in filename)
 * @param {{ selectedOnly?: boolean }} options
 */
export function exportOverQuotaUsersToExcel(users, studyId, { selectedOnly = false } = {}) {
  const rows = users.map((user) => ({
    wh_mo_id: user.wh_mo_id,
    cnt_id: user.cnt_id,
    age: user.age ?? '',
    gender: formatGender(user.gender),
    cnq_ids: (user.quota_data ?? []).map((quota) => quota.cnq_id).join(', '),
    quota_names: formatQuotaNames(user.quota_data),
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Over Quota Users');

  const scope = selectedOnly ? 'selected' : 'all';
  const filename = `over-quota-users-study-${studyId}-${scope}.xlsx`;
  XLSX.writeFile(workbook, filename);
}
